// extracted by mini-css-extract-plugin
module.exports = {"main":"premium-filter_main__7up82","starIcon":"premium-filter_starIcon__BJnWt"};